import { html, View } from 'rune-ts';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import klass from './TabCreatorShopView.module.scss';
import { TRuneNode } from '@services/MarppleShop/shared/type/TRuneNode.ts';

export type TProps = (
  | {
      state: 'Select';
      device: 'PC';
      menu_title: TRuneNode;
    }
  | {
      state: 'Select';
      device: 'MO';
      menu_title: TRuneNode;
    }
  | {
      state: 'Unselect';
      device: 'PC';
      menu_title: TRuneNode;
    }
  | {
      state: 'Unselect';
      device: 'MO';
      menu_title: TRuneNode;
    }
) &
  Pick<HTMLAnchorElement, 'href'>;

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=22707-7105&m=dev
 */
export class TabCreatorShopView extends View<TProps> {
  protected override template({ state, device, menu_title, href }: TProps) {
    return html`<a
      class="${classes(
        (() => {
          if (state === 'Select' && device === 'PC') {
            return font('18_bold');
          } else if (state === 'Unselect' && device === 'PC') {
            return font('18_medium');
          } else if (state === 'Select' && device === 'MO') {
            return font('14_bold');
          } else if (state === 'Unselect' && device === 'MO') {
            return font('14_medium');
          }
        })(),
        {
          [klass.select_pc]: state === 'Select' && device === 'PC',
          [klass.unselect_pc]: state === 'Unselect' && device === 'PC',
          [klass.select_mo]: state === 'Select' && device === 'MO',
          [klass.unselect_mo]: state === 'Unselect' && device === 'MO',
        },
      )}"
      href="${href}"
    >
      ${menu_title} ${state === 'Select' ? html`<div class="${klass.line}"></div>` : null}
    </a>`;
  }
}
